export enum GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
